import React from "react";
import { Button, Text } from "@gusarov-studio/rubik-ui";
import { routesMap } from "../../../router/routesMap";

const ErrorFallback = () => {
  "use memo";

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = routesMap.newFile.url();
  };

  return (
    <div className="bg-(--bg-primary) flex min-h-screen flex-col items-center justify-center gap-4">
      <Text
        weight="700"
        size={20}
        color="primary"
        align="center"
      >
        Oops. Something went wrong.
      </Text>
      <div className="flex flex-wrap justify-center gap-2">
        <Button
          variant="primary"
          onClick={handleGoHome}
        >
          Go to home page
        </Button>

        <Button
          variant="primary"
          onClick={handleReload}
        >
          Reload page
        </Button>
      </div>
    </div>
  );
};

export { ErrorFallback };
